import {
  Box,
  Paper,
  Divider,
  Container,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
// import Logo from "Assets/svgs/logo.svg"; // replace path as needed
import Logo from "Assets/images/logo.png";

import { Typography, Button } from "Atoms";
import { useBoundStore } from "Zustand/store/mainStore";
import { useLocation } from "react-router";
import { ArrowBack, CopyAll, Logout } from "@mui/icons-material";
import BasicInfo from "./_tabs/BasicInfo";
import TestReports from "./_tabs/TestReports";
import Attachments from "./_tabs/Attachments";
import Appbar from "Atoms/Appbar";

const TestReportDetail = () => {
  const [tabIndex, setTabIndex] = useState<number>(0);

  const { logout, getTestPlanContent, getTestReportByNodeId } = useBoundStore();

  const location = useLocation();

  const { reportnodeid, project, plannodeid } = location.state;


  const handleTabChange = (_: any, newValue: any) => {
    setTabIndex(newValue);
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (reportnodeid !== null) {
      getTestReportByNodeId(reportnodeid);
    }
  }, [reportnodeid]);

  useEffect(() => {
    if (plannodeid !== null) {
      getTestPlanContent(plannodeid);
    }
  }, [plannodeid]);

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        sx={{ width: "100%", p: 4, borderRadius: 2, height: "100%" }}
        elevation={3}
      >
        {/* 🔷 Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="text"
              onClick={() => {
                window.history.back();
              }}
              startIcon={<ArrowBack />}
            >
              Back
            </Button>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexDirection={"column"}
          >
            <img src={Logo} alt="Logo" style={{ height: 40 }} />
          </Box>
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={logout}
            startIcon={<Logout />}
          >
            Logout
          </Button>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <b>Project : </b> {project?.testproject?.name}{" "}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <b>Plan : </b>

              <Tooltip title={location?.state?.plannodeid}>
                <Typography variant="body2" component={"span"}>
                  {location?.state?.plannodeid.substring(0, 8)}...
                  {location?.state?.plannodeid.substring(
                    location.state?.plannodeid.length - 5
                  )}{" "}
                </Typography>
              </Tooltip>
              <Tooltip title="Copy full Plan ID">
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(location?.state?.plannodeid);
                  }}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  <CopyAll fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
            </Typography>

            <Typography variant="body2" color="text.secondary">
              <b>Report : </b>

              <Tooltip title={location?.state?.reportnodeid}>
                <Typography variant="body2" component={"span"}>
                  {location?.state?.reportnodeid.substring(0, 8)}...
                  {location?.state?.reportnodeid.substring(
                    location.state?.reportnodeid.length - 5
                  )}{" "}
                </Typography>
              </Tooltip>
              <Tooltip title="Copy full Report ID">
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(
                      location?.state?.reportnodeid
                    );
                  }}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  
                >
                  <CopyAll fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <>
          {/* 🔷 Tabs */}
  
          <Appbar
            tabs={[
              { label: "Basic Info", value: 0 },
              { label: "Test Results", value: 1 },
              { label: "Test Reports", value: 2 },
            ]}
            value={tabIndex}
            onChange={handleTabChange}
            primaryColor="primary" // appbar bg
            textColor="#FFFFFF" // tab text
            activeBarColor="#FFFFFF" // underline/indicator
          />
          
          <Box mt={2}>
            {tabIndex === 0 && (
              <BasicInfo
                projectnodeid={project?.testproject.nodeid}
                testplannodeid={location?.state?.plannodeid}
              />
            )}
            {tabIndex === 1 && (
              <TestReports
                testplannodeid={location?.state?.plannodeid}
                reportnodeid={reportnodeid}
              />
            )}
            {tabIndex === 2 && <Attachments reportnodeid={reportnodeid} />}
          </Box>
        </>
      </Paper>
    </Container>
  );
};

export default TestReportDetail;
